import { render } from "./RevenueUpdateView.vue?vue&type=template&id=55646fcc"
import script from "./RevenueUpdateView.vue?vue&type=script&lang=js"
export * from "./RevenueUpdateView.vue?vue&type=script&lang=js"

import "./RevenueUpdateView.vue?vue&type=style&index=0&id=55646fcc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__